import React from 'react';

export const TestPrepSVG: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg
    width="93"
    height="61"
    viewBox="0 0 93 61"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_1865_1052"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="93"
      height="61"
    >
      <rect x="0.445312" y="0.224609" width="92.0781" height="60.502" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1865_1052)">
      <g filter="url(#filter0_d_1865_1052)">
        <path
          d="M87.8045 5.24115C87.796 3.11133 86.0588 1.39035 83.9244 1.39725L54.0525 1.49371C51.9182 1.5006 50.1949 3.23275 50.2034 5.36257L50.3604 44.4685C50.3689 46.5983 52.1061 48.3193 54.2405 48.3124L84.1124 48.2159C86.2467 48.209 87.9701 46.4769 87.9615 44.3471L87.8045 5.24115Z"
          fill="white"
        />
      </g>
      <path
        d="M57.6178 13.942C57.6175 13.0873 58.3115 12.3948 59.1679 12.3951L79.6595 12.403C80.516 12.4033 81.2105 13.0964 81.2109 13.951V13.951C81.2112 14.8057 80.5172 15.4982 79.6607 15.4979L59.1691 15.49C58.3127 15.4897 57.6181 14.7966 57.6178 13.942V13.942Z"
        fill="#828282"
      />
      <path
        d="M57.6256 30.0416C57.6253 29.187 57.9213 28.4943 58.2869 28.4944L67.0327 28.4978C67.3983 28.4979 67.6949 29.1908 67.6952 30.0455C67.6955 30.9001 67.3995 31.5928 67.0339 31.5927L58.2881 31.5893C57.9225 31.5892 57.6259 30.8962 57.6256 30.0416Z"
        fill="#828282"
      />
      <path
        d="M57.6178 21.9908C57.6175 21.1362 58.3115 20.4436 59.1679 20.444L79.6595 20.4518C80.516 20.4522 81.2105 21.1452 81.2109 21.9999V21.9999C81.2112 22.8545 80.5172 23.5471 79.6607 23.5467L59.1691 23.5389C58.3127 23.5385 57.6181 22.8454 57.6178 21.9908V21.9908Z"
        fill="#828282"
      />
      <path
        d="M68.2831 47.4977C68.8239 48.014 70.709 49.0025 69.9146 50.2694C68.977 51.7645 63.4284 51.5503 63.4284 51.5503C63.4284 51.5503 63.3817 51.5413 61.6593 53.1603C60.508 54.2425 62.3116 50.4155 61.0086 51.9561C60.1239 53.0021 59.2581 55.2141 58.9473 54.1082C58.7027 53.2378 57.9387 55.4299 58.3714 53.9175C58.8081 52.3911 59.5187 51.5 60.2605 50.1434C61.0874 48.6312 60.5495 47.3427 61.6961 46.093C64.34 43.2111 62.6067 45.5278 65.3266 46.5185C66.595 46.9806 67.4587 46.7108 68.2831 47.4977Z"
        fill="#DB5442"
      />
      <path
        d="M67.5053 47.649C67.9046 47.943 70.5866 48.6727 69.5843 49.7814C68.5821 50.8902 66.5593 50.8503 65.0452 50.8294C63.5564 51.1587 63.4066 51.0782 61.7271 52.6569C60.6045 53.7121 60.1815 54.6688 58.911 56.171C58.0483 57.191 56.9997 57.0279 56.6967 55.9497C56.4581 55.1008 56.326 54.5494 56.748 53.0746C57.1739 51.5862 57.8667 50.7174 58.5901 49.3945C59.3964 47.92 59.4655 46.6073 60.5835 45.3887C63.1616 42.5786 60.0053 45.819 62.829 46.4414C64.0532 46.7113 66.7468 47.0906 67.5053 47.649Z"
        fill="#F99746"
      />
      <path
        d="M61.4651 42.422C61.7676 42.0292 62.7112 41.0743 63.7981 42.1002C64.8849 43.1261 64.453 44.8182 64.3994 46.3314L63.5455 48.2304L62.0076 51.024C62.0076 51.024 62.3861 53.2104 61.1919 52.0664C58.4381 49.4283 59.4737 49.8809 60.1569 47.0713C60.4532 45.8531 60.8905 43.1683 61.4651 42.422Z"
        fill="#F99746"
      />
      <path
        d="M62.9576 41.1254C65.6334 41.602 64.942 46.1044 64.3555 46.266C64.3555 46.266 64.896 41.8743 62.7011 41.9382C60.5061 42.002 59.5468 50.5241 59.5468 50.5241C59.5468 50.5241 56.3469 54.4614 56.7689 52.9867C57.1948 51.4983 58.0594 50.9475 58.7828 49.6247C59.5891 48.1502 59.7656 40.5569 62.9576 41.1254Z"
        fill="#DB5442"
      />
      <path
        d="M59.9867 52.2583C60.7359 53.1112 62.2688 53.6111 62.2688 53.6111C62.2688 53.6111 60.6418 56.4779 59.375 57.1935C57.8545 58.0524 56.7907 56.5332 55.746 55.2197C54.7248 53.9357 54.6329 52.9574 55.408 51.8727C56.6247 50.17 59.1867 47.6983 59.1867 47.6983C59.1867 47.6983 58.6054 50.6857 59.9867 52.2583Z"
        fill="#61B195"
      />
      <path
        d="M59.9867 52.2583C60.7359 53.1112 62.2688 53.6111 62.2688 53.6111C62.2688 53.6111 60.6418 56.4779 59.375 57.1935C57.8545 58.0524 56.7907 56.5332 55.746 55.2197C54.7248 53.9357 54.6329 52.9574 55.408 51.8727C56.6247 50.17 59.1867 47.6983 59.1867 47.6983C59.1867 47.6983 58.6054 50.6857 59.9867 52.2583Z"
        fill="#61B195"
      />
      <path
        d="M59.9808 52.2623C60.73 53.1152 62.2629 53.6151 62.2629 53.6151C62.2629 53.6151 60.6358 56.4818 59.369 57.1975C58.2037 57.8558 57.4718 57.0462 57.4718 57.0462C57.4718 57.0462 59.2024 56.8365 59.9775 55.7518C61.1942 54.0491 59.9808 52.2623 59.9808 52.2623Z"
        fill="black"
        fillOpacity="0.33"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M62.1972 53.0804C62.1972 53.0804 62.1972 53.0804 62.1972 53.0804L62.1976 53.0805L62.1963 53.0801L62.1882 53.0776C62.1806 53.0752 62.1683 53.0713 62.152 53.0658C62.1192 53.0549 62.0701 53.038 62.0083 53.015C61.8842 52.9687 61.7104 52.8984 61.5148 52.8033C61.1169 52.6098 60.6598 52.3284 60.3382 51.9623C59.7337 51.2741 59.5091 50.3418 59.4466 49.541C59.4157 49.1458 59.4254 48.7959 59.4427 48.5455C59.4514 48.4206 59.4619 48.3213 59.4701 48.2545C59.4741 48.2211 59.4776 48.1959 59.48 48.1797C59.4811 48.1716 59.482 48.1658 59.4826 48.1624L59.483 48.1593L59.4831 48.1591C59.5234 47.9144 59.356 47.6929 59.1089 47.6643C58.8617 47.6357 58.6285 47.811 58.588 48.0558L59.0355 48.1076C58.588 48.0558 58.5879 48.056 58.5879 48.0561L58.5878 48.0565L58.5877 48.0574L58.5873 48.0599L58.5861 48.0677C58.5851 48.0741 58.5837 48.083 58.5821 48.0942C58.5788 48.1166 58.5745 48.1484 58.5696 48.1887C58.5597 48.2693 58.5477 48.3841 58.5378 48.5259C58.5182 48.8089 58.5073 49.203 58.5422 49.6501C58.6112 50.5339 58.8636 51.6792 59.6404 52.5636C60.068 53.0504 60.6397 53.3914 61.0832 53.6071C61.3084 53.7166 61.5085 53.7976 61.6532 53.8515C61.7256 53.8785 61.7846 53.8989 61.8264 53.9128C61.8472 53.9197 61.8638 53.925 61.8757 53.9288L61.8899 53.9332L61.8942 53.9345L61.8956 53.935L61.8964 53.9352C61.8965 53.9352 61.8966 53.9353 62.0468 53.5078L61.8964 53.9352C62.1327 54.006 62.3918 53.8721 62.4747 53.636C62.5577 53.4001 62.4336 53.1515 62.1976 53.0805M62.1972 53.0804C62.1972 53.0804 62.1972 53.0804 62.1972 53.0804Z"
        fill="#282F33"
      />
      <path
        d="M63.7812 35.5918L69.2477 37.1385L63.4581 57.6C63.3758 57.8911 63.0729 58.0604 62.7818 57.978L58.3698 56.7296C58.0786 56.6473 57.9094 56.3444 57.9917 56.0533L63.7812 35.5918Z"
        fill="#FDDA5D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M68.3675 32.1231C68.265 31.5484 67.545 31.3447 67.1565 31.7805L63.8837 35.4525C63.8431 35.4981 63.8097 35.5469 63.7834 35.5977L69.2406 37.1418C69.2447 37.0847 69.2419 37.0257 69.2312 36.9655L68.3675 32.1231Z"
        fill="black"
      />
      <path
        d="M58.8906 52.8516L64.357 54.3983L63.4376 57.6477C63.3624 57.9134 63.0861 58.0678 62.8204 57.9926L58.3162 56.7182C58.0505 56.643 57.896 56.3667 57.9712 56.101L58.8906 52.8516Z"
        fill="#BF7066"
      />
      <path
        d="M62.8065 56.9888C63.5091 56.6569 69.247 37.1897 69.247 37.1897L63.5022 57.4564C63.4213 57.8825 63.1488 58.1059 62.6386 57.9391L58.5184 56.7733C58.1467 56.6681 61.2904 57.7048 62.8065 56.9888Z"
        fill="#040404"
        fillOpacity="0.35"
      />
      <path
        d="M59.8546 40.0452L60.153 38.2305L62.9789 37.6208L64.4807 38.3396L65.2515 40.2979L64.6174 41.6516L62.4575 42.1596L60.3367 41.3352L59.8546 40.0452Z"
        fill="#F99746"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M60.7454 41.8922C60.1369 41.7488 59.4005 40.9326 59.6871 39.2659C60.0894 36.926 62.2185 37.2433 63.2745 37.5796C64.1393 37.7375 65.7942 38.7992 65.3329 40.7372C64.8317 42.8429 62.095 42.5433 60.7454 41.8922ZM61.0751 41.4694C61.0772 41.4682 61.0784 41.4675 61.0784 41.4675C61.0784 41.4675 64.4341 42.7023 64.9657 40.7406C65.2696 39.6189 64.515 38.7775 63.813 38.2625C63.3189 38.1309 60.5383 37.4764 60.0543 39.2625C59.6725 40.6714 60.5502 41.2534 61.0751 41.4694Z"
        fill="#DB5442"
      />
      <path
        d="M63.7301 41.7585L65.7928 40.3928L69.9738 43.8896L71.2299 46.7815L70.4023 49.8413L68.2971 50.5718L66.8829 50.0355L65.1025 47.632L63.1521 43.7369L63.7301 41.7585Z"
        fill="#F99746"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M63.1638 44.8772C62.518 43.8521 62.3316 41.9743 64.2422 40.738C66.9244 39.0026 69.3552 42.407 70.3951 44.2728C71.3554 45.6844 72.4897 49.1384 70.1044 50.39C67.5126 51.75 64.2878 47.4812 63.1638 44.8772ZM63.9774 44.9366C63.9813 44.9385 63.9833 44.9395 63.9833 44.9395C63.9833 44.9395 66.4372 51.4619 68.9345 50.2888C70.3625 49.618 70.8729 47.2604 70.4516 45.7311C69.9411 44.8837 66.989 40.1996 64.7153 41.2676C62.9217 42.1101 63.5058 43.9607 63.9774 44.9366Z"
        fill="#DB5442"
      />
      <path
        d="M24.5726 56.6977C37.6156 56.6251 48.1307 46.0775 48.0587 33.1389C47.9866 20.2004 37.3548 9.7705 24.3118 9.84312C11.2688 9.91574 0.75371 20.4634 0.825748 33.4019C0.897785 46.3404 11.5296 56.7703 24.5726 56.6977Z"
        fill="#FFA154"
      />
      <path
        d="M31.7032 12.1251C34.4337 11.1248 36.208 9.11485 35.6661 7.63574C35.1243 6.15664 32.4715 5.76851 29.7409 6.76883C27.0104 7.76916 25.2361 9.77913 25.778 11.2582C26.3199 12.7373 28.9727 13.1255 31.7032 12.1251Z"
        fill="#FFA154"
      />
      <path
        d="M25.8398 10.4302C27.8472 6.98212 27.9508 3.2998 26.0712 2.20555C24.1916 1.11129 21.0406 3.01947 19.0332 6.46758C17.0258 9.91569 16.9222 13.598 18.8017 14.6923C20.6813 15.7865 23.8324 13.8783 25.8398 10.4302Z"
        fill="#FFA154"
      />
      <path
        d="M14.4631 41.6873C14.1189 40.5621 15.054 39.541 16.2306 39.541H32.5069C33.6534 39.541 34.583 40.5137 34.2845 41.6207C33.8063 43.3939 32.8473 45.0161 31.4949 46.298C29.6279 48.0678 27.1533 49.0543 24.5807 49.0543H24.3278C21.7541 49.0543 19.2733 48.0924 17.3722 46.3575C16.0086 45.113 15.007 43.4653 14.4631 41.6873Z"
        fill="#282F33"
      />
      <path
        d="M19.2422 46.4957C20.0209 47.3106 22.2873 47.9117 24.3526 47.9172C28.1426 47.927 29.4317 46.4957 29.4317 46.4957C29.4317 46.4957 23.9836 43.4116 19.2422 46.4957Z"
        fill="#D84C42"
      />
      <path
        opacity="0.9"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.4141 54.1478C36.4584 54.0461 46.9757 43.8055 46.9028 31.2748C46.8765 26.6306 45.3771 22.1146 42.6204 18.377C46.2964 22.528 48.3387 27.8734 48.367 33.418C48.4406 46.2447 37.9253 56.725 24.8814 56.8264C20.5281 56.8786 16.2452 55.7259 12.5063 53.4957C8.76728 51.2656 5.71791 48.0448 3.69531 44.1896C5.93296 47.3191 8.89569 49.8598 12.3299 51.5941C15.764 53.3284 19.5673 54.2046 23.4141 54.1478V54.1478Z"
        fill="#D84C42"
      />
      <path
        opacity="0.9"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.6292 1.69387C28.509 2.78889 28.4043 6.47229 26.3956 9.92041C25.583 11.3697 24.4576 12.6198 23.1014 13.5797C23.8931 12.7998 24.5756 11.9164 25.1304 10.9534C27.1394 7.50493 27.2438 3.82187 25.3643 2.72685C24.3568 2.14002 22.9838 2.41564 21.6172 3.32826C23.3574 1.63793 25.3077 0.923969 26.6292 1.69387ZM34.5513 7.14151C35.0937 8.62029 33.3197 10.6307 30.5892 11.6311C29.2813 12.1523 27.855 12.3028 26.4671 12.066C27.5106 12.8915 29.6461 12.9814 31.831 12.1789C34.5611 11.1782 36.3352 9.16814 35.7931 7.68935C35.5514 7.03031 34.8907 6.5879 33.9902 6.38855C34.2439 6.58219 34.4383 6.84303 34.5513 7.14151V7.14151Z"
        fill="#D84C42"
      />
      <path
        opacity="0.9"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.426 38.1431C41.0608 38.0967 45.6036 33.4057 45.5727 27.6658C45.5666 25.5549 44.9216 23.4953 43.7227 21.7578C45.3244 23.6969 46.2019 26.1326 46.205 28.6476C46.2369 34.5231 41.6961 39.3239 36.0596 39.3703C32.0714 39.4042 28.9311 36.765 27.2344 33.302C29.079 36.0778 31.8833 38.1719 35.426 38.1431Z"
        fill="#D84C42"
      />
      <path
        opacity="0.9"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.8869 38.1431C17.5217 38.0967 22.0645 33.4057 22.0337 27.6658C22.0275 25.5549 21.3826 23.4953 20.1837 21.7578C21.7853 23.6969 22.6629 26.1326 22.6659 28.6476C22.6978 34.5231 18.157 39.3239 12.5206 39.3703C8.53238 39.4042 5.39208 36.765 3.69531 33.302C5.53989 36.0778 8.34423 38.1719 11.8869 38.1431Z"
        fill="#D84C42"
      />
      <path
        d="M36.3975 35.9141C40.4787 35.9141 43.7871 32.6056 43.7871 28.5244C43.7871 24.4432 40.4787 21.1348 36.3975 21.1348C32.3163 21.1348 29.0078 24.4432 29.0078 28.5244C29.0078 32.6056 32.3163 35.9141 36.3975 35.9141Z"
        fill="#F9F3EB"
      />
      <path
        d="M36.4093 32.5198C38.6158 32.5198 40.4045 30.731 40.4045 28.5245C40.4045 26.318 38.6158 24.5293 36.4093 24.5293C34.2028 24.5293 32.4141 26.318 32.4141 28.5245C32.4141 30.731 34.2028 32.5198 36.4093 32.5198Z"
        fill="#282F33"
        stroke="#282F33"
      />
      <path
        d="M38.262 28.2154C39.3214 28.2154 40.1802 27.3565 40.1802 26.2971C40.1802 25.2377 39.3214 24.3789 38.262 24.3789C37.2026 24.3789 36.3437 25.2377 36.3437 26.2971C36.3437 27.3565 37.2026 28.2154 38.262 28.2154Z"
        fill="white"
      />
      <path
        d="M34.6646 32.8682C35.4199 32.8682 36.0323 32.2559 36.0323 31.5005C36.0323 30.7451 35.4199 30.1328 34.6646 30.1328C33.9092 30.1328 33.2969 30.7451 33.2969 31.5005C33.2969 32.2559 33.9092 32.8682 34.6646 32.8682Z"
        fill="white"
      />
      <path
        d="M12.2959 35.9141C16.3771 35.9141 19.6856 32.6056 19.6856 28.5244C19.6856 24.4432 16.3771 21.1348 12.2959 21.1348C8.21471 21.1348 4.90625 24.4432 4.90625 28.5244C4.90625 32.6056 8.21471 35.9141 12.2959 35.9141Z"
        fill="#F9F3EB"
      />
      <path
        d="M12.3077 32.5198C14.5142 32.5198 16.303 30.731 16.303 28.5245C16.303 26.318 14.5142 24.5293 12.3077 24.5293C10.1012 24.5293 8.3125 26.318 8.3125 28.5245C8.3125 30.731 10.1012 32.5198 12.3077 32.5198Z"
        fill="#282F33"
        stroke="#282F33"
      />
      <path
        d="M14.1604 28.2154C15.2198 28.2154 16.0786 27.3565 16.0786 26.2971C16.0786 25.2377 15.2198 24.3789 14.1604 24.3789C13.101 24.3789 12.2422 25.2377 12.2422 26.2971C12.2422 27.3565 13.101 28.2154 14.1604 28.2154Z"
        fill="white"
      />
      <path
        d="M10.563 32.8682C11.3184 32.8682 11.9307 32.2559 11.9307 31.5005C11.9307 30.7451 11.3184 30.1328 10.563 30.1328C9.80765 30.1328 9.19531 30.7451 9.19531 31.5005C9.19531 32.2559 9.80765 32.8682 10.563 32.8682Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.618 22.7425C14.618 22.7425 14.619 22.743 14.255 23.557L14.619 22.743C15.0686 22.944 15.2701 23.4715 15.0691 23.9211C14.8693 24.3678 14.3472 24.5696 13.8994 24.3749L13.8968 24.3738C13.8905 24.3713 13.8761 24.3657 13.8542 24.358C13.8104 24.3427 13.7371 24.3195 13.6385 24.296C13.4408 24.249 13.1464 24.2025 12.7859 24.2154C12.0836 24.2405 11.0716 24.4913 9.97985 25.525C8.86174 26.5838 8.43802 27.6188 8.27976 28.3565C8.19958 28.7303 8.18589 29.0362 8.19057 29.2401C8.1929 29.3418 8.19981 29.4175 8.20511 29.4626C8.20776 29.4852 8.21 29.5 8.21104 29.5064L8.21146 29.509C8.30261 29.9888 7.99039 30.4535 7.51042 30.5497C7.0275 30.6463 6.55763 30.3332 6.46094 29.8503L7.33534 29.6753C6.46094 29.8503 6.46073 29.8493 6.46073 29.8493L6.46052 29.8482L6.46005 29.8458L6.459 29.8403L6.45647 29.8267C6.45461 29.8164 6.45242 29.8037 6.45 29.7887C6.44518 29.7586 6.43948 29.7191 6.43382 29.6709C6.42249 29.5746 6.41125 29.4429 6.40753 29.281C6.4001 28.9573 6.42266 28.5104 6.53593 27.9824C6.76457 26.9167 7.35654 25.5528 8.75358 24.23C10.177 22.8821 11.6091 22.4728 12.7222 22.433C13.2693 22.4135 13.7254 22.4834 14.0512 22.5609C14.2144 22.5997 14.3462 22.6407 14.442 22.6742C14.4899 22.6909 14.529 22.7058 14.5586 22.7176C14.5734 22.7235 14.5859 22.7287 14.596 22.733L14.6093 22.7387L14.6146 22.741L14.6169 22.742L14.618 22.7425Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M38.3211 22.7425C38.3216 22.7427 38.3221 22.743 37.9581 23.557L38.3221 22.743C38.7717 22.944 38.9732 23.4715 38.7722 23.9211C38.5724 24.3678 38.0503 24.5696 37.6026 24.3749C37.602 24.3746 37.6011 24.3743 37.6 24.3738C37.5936 24.3713 37.5792 24.3657 37.5574 24.358C37.5135 24.3427 37.4402 24.3195 37.3417 24.296C37.1439 24.249 36.8496 24.2025 36.489 24.2154C35.7867 24.2405 34.7747 24.4913 33.683 25.525C32.5649 26.5838 32.1411 27.6188 31.9829 28.3565C31.9027 28.7303 31.889 29.0362 31.8937 29.2401C31.896 29.3418 31.9029 29.4175 31.9082 29.4626C31.9109 29.4852 31.9131 29.5 31.9142 29.5064C31.9143 29.5075 31.9145 29.5084 31.9146 29.509C32.0057 29.9888 31.6935 30.4535 31.2135 30.5497C30.7306 30.6463 30.2608 30.3332 30.1641 29.8503L31.0385 29.6753C30.1641 29.8503 30.164 29.8498 30.1639 29.8493L30.1636 29.8482L30.1632 29.8458L30.1621 29.8403L30.1596 29.8267C30.1577 29.8164 30.1555 29.8037 30.1531 29.7887C30.1483 29.7586 30.1426 29.7191 30.1369 29.6709C30.1256 29.5746 30.1144 29.4429 30.1107 29.281C30.1032 28.9573 30.1258 28.5104 30.2391 27.9824C30.4677 26.9167 31.0597 25.5528 32.4567 24.23C33.8801 22.8821 35.3123 22.4728 36.4253 22.433C36.9724 22.4135 37.4286 22.4834 37.7544 22.5609C37.9176 22.5997 38.0494 22.6407 38.1451 22.6742C38.193 22.6909 38.2321 22.7058 38.2617 22.7176C38.2766 22.7235 38.289 22.7287 38.2991 22.733L38.3124 22.7387L38.3177 22.741L38.32 22.742L38.3211 22.7425Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M46.6382 26.9093H45.9744C45.627 24.6603 44.5558 22.5858 42.9233 21.0003C41.1052 19.2349 38.6727 18.2447 36.1386 18.2383C33.9564 18.2324 31.8362 18.9643 30.1224 20.3151C28.6452 21.4754 27.5156 23.0197 26.8573 24.7789C26.1046 24.2794 25.2235 24.0081 24.3202 23.9975C23.416 24.003 22.5335 24.2748 21.783 24.7789C21.1323 23.0155 20.0014 21.4693 18.5179 20.3151C16.8041 18.9643 14.6839 18.2324 12.5017 18.2383C9.97051 18.2411 7.53851 19.223 5.71499 20.9786C4.08551 22.5794 3.01554 24.6628 2.66386 26.9198H1.99973C1.58289 26.9334 1.18765 27.1085 0.897572 27.4081C0.607495 27.7078 0.445312 28.1085 0.445312 28.5256C0.445312 28.9426 0.607495 29.3433 0.897572 29.643C1.18765 29.9427 1.58289 30.1178 1.99973 30.1313H2.66318C3.00808 32.3843 4.07945 34.463 5.71432 36.0512C7.53286 37.817 9.96626 38.8073 12.5011 38.8132C17.9931 38.8132 22.4681 34.21 22.4681 28.5471V28.5257C22.4681 27.8941 23.2068 26.9324 24.3202 26.9324C25.4335 26.9324 26.1722 27.8958 26.1722 28.5257V28.5366C26.1722 34.1981 30.6472 38.8023 36.1392 38.8023C38.6758 38.8055 41.1124 37.8138 42.926 36.0403C44.5611 34.4481 45.6323 32.3661 45.9771 30.11H46.6409C47.0563 30.0964 47.4502 29.9219 47.7393 29.6233C48.0284 29.3246 48.19 28.9253 48.19 28.5096C48.19 28.094 48.0284 27.6946 47.7393 27.396C47.4502 27.0974 47.0563 26.9228 46.6409 26.9093H46.6382ZM19.5326 28.5261C19.5326 32.5219 16.2934 35.7611 12.2975 35.7611C8.30174 35.7611 5.0625 32.5219 5.0625 28.5261C5.0625 24.5303 8.30174 21.291 12.2975 21.291C16.2934 21.291 19.5326 24.5303 19.5326 28.5261ZM36.2194 35.7611C40.2152 35.7611 43.4545 32.5219 43.4545 28.5261C43.4545 24.5303 40.2152 21.291 36.2194 21.291C32.2236 21.291 28.9844 24.5303 28.9844 28.5261C28.9844 32.5219 32.2236 35.7611 36.2194 35.7611Z"
        fill="#282F34"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_1865_1052"
        x="46.2031"
        y="1.39648"
        width="45.7578"
        height="54.916"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1865_1052"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1865_1052"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default TestPrepSVG;
